import React from 'react';
import classNames from 'classnames';

export default function Indicator({
    children,
    bg,
    count,
    bottom = null,
    right = null,
    border = null,
}) {
    if (!count || count === 0) {
        return children;
    }
    let xClass = right ? '-right-2' : '-left-1';
    let yClass = bottom ? '-bottom-1' : '-top-1';

    return (
        <div className="relative cursor-pointer">
            <div>{children}</div>
            <div className={classNames('absolute', xClass, yClass)}>
                <div
                    className={classNames(
                        'h-4',
                        'w-4',
                        'flex',
                        'rounded-full',
                        'text-white',
                        'relative',
                        'justify-center',
                        'text-sm',
                        'font-semibold',
                        'px-1.5',
                        bg,
                        {
                            'bg-red-400': !bg,
                            'border-white group-hover:border-blue-gray-100 group-active:border-blue-gray-150 border-2':
                                border,
                        },
                    )}
                ></div>
            </div>
        </div>
    );
}
